module.exports = __webpack_public_path__ + "static/EuclidFlex-Regular-WebS-44871334633daa01ea2c8f3582fb0471.woff";